/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

function loadScripts() {
  // Add the src and a condition required to load the script
  window.ScriptsLoaded = ScriptLoader({
    './components/global': true,
    './elements/header': document.querySelector('.js-header'),
    './elements/locations-map': document.querySelector('.js-locations'),
    './elements/tabbed-navigation': document.querySelector('.js-tabbed-navigation'),
    './marmalade/elements/mobile-menu': window.MenuSets && window.MenuSets.Header,
    './marmalade/elements/banner': document.querySelector('.js-banner'),
    './marmalade/elements/search': document.querySelector('.js-search-modal'),
    './marmalade/elements/buttons': document.querySelector('p .button, input[type="submit"]'),
    './marmalade/elements/videos': document.querySelector('[data-video]'),
    './marmalade/elements/video-modals': document.querySelector('[data-video-modal]'),
    './marmalade/elements/forms': document.querySelector('form.userform, .js-form form'),
    './marmalade/components/google-recaptcha': document.querySelector('form'),
    './pages/blog-holder': document.querySelector('.js-blog-holder'),
    './pages/product-benefits': document.querySelector('.js-product-benefits'),
    './pages/product-holder': document.querySelector('.js-products-holder'),
    './pages/documents': document.querySelector('.js-documents'),
    './products/product-gallery': document.querySelector('.js-product-gallery'),
    './calculators/index': window.applications
  });
}
;

// Once the scripts have loaded
window.addEventListener('scripts-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  document.body.classList.add('scripts-loaded');
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadScripts);
} else {
  loadScripts();
}